export default __webpack_public_path__ + "static/media/redux.954b3f42.svg";